import PropTypes from 'prop-types'

import {List} from 'immutable'

import FuneralPackageGroup from './FuneralPackageGroup'

import essentialsIcon from './essentials-icon.svg'
import funeralMerchandiseIcon from './funeral-merchandise-icon.svg'
import funeralServicesIcon from './funeral-services-icon.svg'
import guaranteedIcon from './guaranteed-icon.svg'

import './funeralPackageDetails.scss'

const FuneralPackageDetails = ({
  essentials = List(),
  merchandise = List(),
  packageName,
  services = List()
}) => {
  // The package (e.g. "Traditional Casketed Service") names the services group,
  // mirroring how Sales Studio subtitles its Funeral Services card.
  const groups = [
    {icon: funeralServicesIcon, items: services, label: 'Funeral services', subLabel: packageName},
    {icon: funeralMerchandiseIcon, items: merchandise, label: 'Funeral merchandise'},
    {icon: essentialsIcon, items: essentials, label: 'Essentials'}
  ]

  if (groups.every(group => !group.items || group.items.isEmpty())) return null

  const hasGuaranteedItems = groups.some(group => (
    group.items.some(item => item.get('is-guaranteed') || item.get('guaranteed'))
  ))

  return (
    <div
      className='funeral-package-details'
      data-testid='funeral-package-details'>
      <div className='section-title'>Prearrangement details</div>
      <div className='details'>
        {
          groups.map(group => (
            <FuneralPackageGroup
              icon={group.icon}
              items={group.items}
              key={group.label}
              label={group.label}
              subLabel={group.subLabel}
            />
          ))
        }
      </div>
      {hasGuaranteedItems && (
        <>
          <div className='footer'>
            For more details, please see the Goods &amp; Services form.
          </div>
          <div className='footnote-container'>
            <img alt='' src={guaranteedIcon} />
            <div className='footnote'>Guaranteed good/service</div>
          </div>
        </>
      )}
    </div>
  )
}

FuneralPackageDetails.propTypes = {
  essentials: PropTypes.instanceOf(List),
  merchandise: PropTypes.instanceOf(List),
  packageName: PropTypes.string,
  services: PropTypes.instanceOf(List)
}

export default FuneralPackageDetails
